import PropTypes from 'prop-types';
import searchUrl from './search.svg';

export const YOU_SEARCH_ICON_URL = searchUrl;

export const YouSearchIcon = ({ size = 18, alt = '' }) => (
  <img
    src={searchUrl}
    alt={alt}
    width={size}
    height={size}
    data-testid="you-search-icon"
  />
);

YouSearchIcon.propTypes = {
  size: PropTypes.number,
  alt: PropTypes.string,
};

export default YouSearchIcon;
